export default __webpack_public_path__ + "static/media/cousera.fce26a08.jpg";